export default __webpack_public_path__ + "static/media/arrow.ac26d546.svg";